<script lang="ts">
	import { fade } from 'svelte/transition';
	import { browser } from '$app/environment';
	import { onDestroy, onMount } from 'svelte';
	import Size from './size';

	export let type: Size = Size.Auto;
	export let closeModal = (): void => undefined;
	let modalRef: HTMLElement | null = null;

	if (browser) {
		onMount(() => {
			document.body.style.overflow = 'hidden';
			let hubContainer = document.getElementById('hubContainer');
			if (hubContainer && modalRef) {
				hubContainer.appendChild(modalRef);
			}
		});

		onDestroy(() => {
			document.body.style.overflow = 'visible';
			if (modalRef) {
				modalRef.remove();
			}
			modalRef = null;
		});
	}
	const onEscape = (e: KeyboardEvent) => {
		if (e.key === 'Escape') closeModal();
	};
</script>

<svelte:body on:keyup={onEscape} />

<div class="placeholder">
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div
		class="background"
		on:click|stopPropagation={closeModal}
		bind:this={modalRef}
		transition:fade|global={{ duration: 300 }}>
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<div class={`wrapper ${type}`} on:click|stopPropagation>
			<slot />
		</div>
	</div>
</div>

<style>
	.placeholder {
		position: relative;
	}

	.background {
		display: flex;
		position: fixed;
		z-index: var(--z-index-Modal);
		flex-direction: column;
		justify-content: center;
		block-size: 100vh;
		inline-size: 100vw;
		background: rgb(0 0 0 / 30%);
		inset-block-start: 0;
		inset-inline-start: 0;
	}

	.wrapper {
		display: block;

		/* position: relative; */
		max-block-size: 90vh;
		inline-size: min-content;
		margin-block: 0;
		margin-inline: auto;
		overflow: hidden;
		border-radius: 0.3rem;
		background: white;
		box-shadow: 0 0 27px 0 #35353580;
		color: black;
	}

	@media screen and (max-width: 575px) {
		.wrapper {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			block-size: 100vh;
			max-block-size: 100vh;
			inline-size: 100%;
			margin: 0;
			border-radius: 0;
			text-align: start;
		}

		.wrapper.small {
			block-size: auto;
		}
	}
</style>
